import { giveawayModuleIds } from 'root/src/client/web/giveaway/descriptions/modules/moduleIds';
export const createGiveawayModal = {
    [giveawayModuleIds.CREATE_GIVEAWAY_MODAL_MODULE_ID]: {
        moduleType: 'modal',
    },
};
